import { Layout } from '../components/Layout'

export function GamesPage() {
  return (
    <Layout>
      <div>Games page</div>
    </Layout>
  )
}
